import { Layout as AntLayout } from 'antd';
import React from "react";
import { LayoutComponent, ReduxState, setSidebarVisibility, useLogout } from 'react-admin';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import Footer from './Footer';
import Notification from './Notification';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { Helmet } from 'react-helmet';
import useGetCurrentResource from './useGetCurrentResource';
import { ErrorBoundary } from "react-error-boundary";
import { Error } from './Error';
import './TopBar.css';

const { Content } = AntLayout;
const Layout: LayoutComponent = ({
    children
}) => {
    const dispatch = useDispatch();
    const currentResource = useGetCurrentResource();
    const logout = useLogout();
    const sidebarOpen = useSelector((state: ReduxState) => state.admin.ui.sidebarOpen);
    let { pathname } = useLocation();
    return (
        <>
            <div className="layout-v2">
                <Helmet>
                    <title>{currentResource} - NetOrca</title>
                </Helmet>
                <TopBar
                    pathName={pathname}
                    toggleSidebar={() => dispatch(setSidebarVisibility(!sidebarOpen))}
                    logout={logout}
                />
                <div className="layout-v2-body">
                    <AntLayout className="layout-dashboard">
                        <Sidebar />
                        <AntLayout>
                            <ErrorBoundary
                                fallbackRender={({ error, resetErrorBoundary }) => (
                                    <Error
                                        error={error}
                                        resetErrorBoundary={resetErrorBoundary}
                                    />
                                )}
                            >
                                <Content className="content-ant layout-v2-content">
                                    {children}
                                </Content>
                            </ErrorBoundary>
                            <Footer />
                        </AntLayout>
                    </AntLayout>
                </div>
                <Notification />
            </div>
        </>
    );
};

export default Layout;
